import axios from "axios";

interface UploadResponse {
    documentMetadataId: string;
}

export class DocumentUploadService {
    private uploadURL = "/api/v1/documents";

    async uploadDocument(document: File, progressCallback: (progress: number) => void): Promise<UploadResponse> {
        const response = await axios.postForm(
            this.uploadURL,
            { file: document },
            {
                onUploadProgress: function (progressEvent: ProgressEvent) {
                    progressCallback(progressEvent.loaded / progressEvent.total);
                },
            }
        );

        return response.data as UploadResponse;
    }
}
